import { AirChfarSchedulePriceQuoteRequest } from "@b2bportal/air-chfar-api";
import { Product, ProductOpaqueValue } from "@b2bportal/purchase-api";
import {
  CartContext,
  FlightPassengerInformationContext,
} from "@checkout/index";
import { CommonParentContext } from "@checkout/states/common";
import { ParentState } from "@checkout/types";
import { FlightContext } from "../Flight";
import { AirChangeForAnyReasonContext } from "./context";

export interface AirChfarProduct extends ProductOpaqueValue {
  type: typeof Product.AirChfar;
  value: AirChfarSchedulePriceQuoteRequest;
}

export enum ChangeForAnyReasonState {
  route = "route",
  initialize = "initialize",
  addProduct = "addProduct",
  error = "error",
}

export interface PartialParentContextWithAirChfar
  extends CartContext,
    CommonParentContext,
    FlightContext {
  [ParentState.passengerInformation]: FlightPassengerInformationContext;
  [ParentState.changeForAnyReason]: AirChangeForAnyReasonContext;
}
